export const AppModalConstant = {
    //response keys
    UNAUTHORIZED: 'UNAUTHORIZED!',
    LIMIT_REACHED_DAY: 'LIMIT_REACHED_DAY',
    LIMIT_REACHED: "LIMIT_REACHED",
    SUCCESS_AIRTEL: 'SUCCESS_AIRTEL',
    INCORRECT: 'INCORRECT',
    INCORRECT_LIMIT: 'AUTHENTICATION_MAXIMUM_INCORRECT_OTP_ENTERED_EXCEPTION',
    //modal titles
    LOGIN_MODAL_TITLE: 'Please login to your account',
    OTP_MODAL_V2_TITLE: 'Login with your mobile number.',
    SSO_MODAL_TITLE: 'Please select a number from your account',
    ERROR_MODAL_TITLE: "We're sorry",
    //modal names
    LOGIN_MOBILE_NUMBER_MODAL: 'LOGIN_MOBILE_NUMBER_MODAL',
    ENTER_OTP_MODAL: 'ENTER_OTP_MODAL',
    OTP_MODAL_V2: 'OTP_MODAL_V2',
    SSO_MODAL: 'SSO_MODAL',
    RETRY_MODAL: " RETRY_MODAL",
    NO_ACCOUNT_FOUND_MODAL: 'NO_ACCOUNT_FOUND_MODAL',
    GENERIC_ERROR_MODAL: 'GENERIC_ERROR_MODAL',
    //modal button values
    ERROR: 'OK, GOT IT',
    LOGIN: 'LOGIN',
    CANCEL: 'CANCEL',
    //error message
    GENERIC_ERROR_MESSAGE: 'An unexpected error has occurred. Our technical staff has been automatically notified and will be looking into this with utmost urgency.',
    GENERIC_ERROR_MESSAGE_APP: 'An unexpected error has occurred. Please try again.',
    LOGIN_SUCCESS_MESSAGE: "You have logged in succesfully.",
    RETRY_MESSAGE: 'An unexpected error has occurred.',
    GENERIC_121_ERROR_MESSAGE: 'An unexpected error has occurred. Please reach out to us at 121.'
}